import { useEffect } from 'react';
import {
  DefaultEventData,
  PartialEventWithRequiredAction,
  useSendAnalytics,
} from 'src/components/AnalyticsProvider/useSendAnalytics';

export interface UseInitialModalAnalytics {
  sendAnalyticsBefore: (
    cb: () => void,
    eventData: PartialEventWithRequiredAction
  ) => void;
}

export const useInitialModalAnalytics = ({
  eventlabel,
}: Partial<DefaultEventData>): UseInitialModalAnalytics => {
  const { sendAnalytics, sendAnalyticsBefore } = useSendAnalytics({
    eventcategory: 'self-service management tool_orderhistory',
    eventlabel,
  });

  useEffect(() => {
    sendAnalytics({ eventaction: 'start receipts download_impression' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    sendAnalyticsBefore,
  };
};
